import { ColumnDef } from '@tanstack/react-table'
import { formatDateForTableSeparatedDateAndTimeSlash } from '@/utils/helpers'
import { Movement } from '../interfaces/inventory'

// Helper function to get operation display text
const getOperationText = (operation: string) => {
  const operationMap = {
    ENTRY: 'Entrada',
    OUT: 'Salida',
    TRANSFER: 'Transferencia',
    ADJUSTMENT: 'Ajuste',
  }
  return operationMap[operation as keyof typeof operationMap] || operation
}

// Helper function to get category display text in Spanish
const getCategoryText = (category: string) => {
  const categoryMap = {
    TRASLATE: 'Traslado',
    SALE: 'Venta',
    BUY: 'Compra',
    FAST_ENTRY: 'Entrada Rápida',
    ADJUST: 'Ajuste',
    DESCOMPOSITION: 'Descomposición',
    ELABORATION: 'Elaboración',
    DISPATCH: 'Despacho',
    CONTAINER: 'Contenedor',
    OUT: 'Salida',
    WASTE: 'Desperdicio',
    TRANSFORMATION: 'Transformación',
    REFUNDED: 'Devuelto',
  }
  return categoryMap[category as keyof typeof categoryMap] || category
}

export const movimientosColumns: ColumnDef<Movement>[] = [
  {
    accessorKey: 'operation',
    header: 'Operaciones',
    cell: ({ row }) => {
      const operation = row.original?.operation || ''
      return (
        <div className="flex w-full flex-col items-start text-left">
          <span className="break-words text-sm font-normal text-gray-800">
            {getOperationText(operation)}
          </span>
        </div>
      )
    },
    enableHiding: false,
  },
  {
    accessorKey: 'category',
    header: 'Categorías',
    cell: ({ row }) => {
      const category = row.original?.category || ''
      return (
        <div className="flex w-full flex-col items-start text-left">
          <span className="break-words text-sm">
            {getCategoryText(category) || '-'}
          </span>
        </div>
      )
    },
    enableHiding: false,
  },
  {
    accessorKey: 'quantity',
    header: 'Cantidad',
    cell: ({ row }) => {
      const quantity = row.original?.quantity || 0

      return (
        <div className="flex w-full flex-col items-start text-left">
          <span className="break-words text-sm font-normal text-gray-800">
            {quantity}
          </span>
        </div>
      )
    },
    enableHiding: false,
  },
  {
    accessorKey: 'createdAt',
    header: 'Fecha y hora',
    cell: ({ row }) => {
      const raw = row.original?.createdAt
      if (!raw)
        return <span className="text-sm font-normal text-gray-800">-</span>

      const { date, time } = formatDateForTableSeparatedDateAndTimeSlash(raw)

      if (!date)
        return <span className="text-sm font-normal text-gray-800">-</span>

      return (
        <div className="flex flex-col">
          <span className="text-sm font-normal text-gray-800">{date}</span>
          <span className="text-xs font-normal text-gray-600">{time}</span>
        </div>
      )
    },
    enableHiding: false,
  },
  {
    accessorKey: 'user',
    header: 'Usuario',
    cell: ({ row }) => {
      // Usar el nuevo campo movedBy.username del backend
      const username = row.original?.movedBy?.username
      return (
        <div className="flex w-full flex-col items-start text-left">
          <span className="break-words text-sm">{username || '-'}</span>
        </div>
      )
    },
    enableHiding: false,
  },
  {
    accessorKey: 'area',
    header: 'Almacén',
    cell: ({ row }) => {
      const area = row.original?.area
      return (
        <div className="flex w-full flex-col items-start text-left">
          <span className="break-words text-sm">{area?.name || '-'}</span>
        </div>
      )
    },
    enableHiding: false,
  },
]
